import axios from "axios";

import { AfiliadoService } from './afiliado.service';
import { ApiService } from '../../api.service';
import LocalStorageKeys from "../../../data/localStorageKeys";

export class BeneficioAfiliadoService {
    static endPoint = 'afiliado/beneficio/';

    static get AuthHeader() {
        return "Token " + localStorage.getItem(LocalStorageKeys.token);
    }

    static get Headers() {
        return { Authorization: this.AuthHeader };
    }

    static countWithFilter(filter) {
        const afiliadoId = AfiliadoService.getId();

        const path = ApiService.api + this.endPoint + afiliadoId + '/count/filter';

        return axios.post(path, filter, { headers: this.Headers });
    }

    static get(beneficioId) {
        const afiliadoId = AfiliadoService.getId();
        const path = ApiService.api + this.endPoint + afiliadoId + '/' + beneficioId;

        return axios.get(path, { headers: this.Headers });
    }

    /**
     * 
     * @param {*} filter 
     * @returns {import("axios").AxiosResponse<{id, porcentajeDescuento, urlLogo}[]>}
     */
    static getWithFilter(filter) {
        const afiliadoId = AfiliadoService.getId();

        const path = ApiService.api + this.endPoint + afiliadoId + '/filter';
        return axios.post(path, filter, { headers: this.Headers });
    }

    static countByComercio(comercioId) {
        const afiliadoId = AfiliadoService.getId();

        const path = ApiService.api + this.endPoint + afiliadoId + '/comercio/' + comercioId + '/count';
        return axios.get(path, { headers: this.Headers });
    }

    static getListByComercio(comercioId, pagination) {
        const afiliadoId = AfiliadoService.getId();

        const path = ApiService.api + this.endPoint + afiliadoId + '/comercio/' + comercioId;
        return axios.post(path, pagination, { headers: this.Headers });
    }
}